var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":null,"title":_vm.$t('menuitems.cancelation.text')}}),_c('Fastview',{ref:"fast-view",attrs:{"id":"fast-view","title":_vm.viewTitle,"item":_vm.viewObject,"filters":_vm.$options.filters}}),_c('List',{attrs:{"dataList":_vm.cancelationData,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'total', type: 'currency', sign: '$'}, {name: 'refund_amount', type: 'currency', sign: '$'}, 
      {name: 'status', color: true}, {name: 'for_date', type: 'date'}],"fields":[ ("for_date: " + (_vm.$t('property.cancelation.date'))),
      ("property: " + (_vm.$t('property.text'))), ("booking: " + (_vm.$t('property.cancelation.booking'))), 
        ("sale: " + (_vm.$t('property.cancelation.sale'))), ("status: " + (_vm.$t('property.status'))), 
        ("total: " + (_vm.$t('property.cancelation.total'))), ("refund_amount: " + (_vm.$t('property.cancelation.refund'))),
        ("notation: " + (_vm.$t('property.cancelation.notation')))
      ],"more":{
        sub: [{
          name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'property_cancelation_status_id', value: 1}
        },{
          name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'property_cancelation_status_id', value: 1}
        },{
          name: 'property.contract', icon: 'bx bx-file', link: 'property-cancellation-contract', column: 'id', target: '_blank' //show: {column: 'property_cancelation_status_id', value: 1}, 
        }] 
      },"filter":{
        search: ['properties.code', 'properties.description'], 
        dropdown: [{
            title: 'property.project',
            field: 'properties.project_id',
            data: this.projectData.data,
            method: function (event) { return _vm.projectChanged(event); },
            default: 1,
            width: 2
          }, {
            title: 'property.status',
            field: 'property_cancelations.property_cancelation_status_id',
            data: this.statusData.data,
            width: 2
          }
        ], 
        date: {
          title: 'general.date',
          field: 'property_cancelations.for_date'
        }
      }},on:{"more":_vm.moreCancelClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }